import React from "react";
import { useRoutes } from "react-router-dom";

// import Home from '../pages/Home';
import Layout from "./Layout";
import Login from "../pages/Auth/Login";
import Home from "../pages/Home";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import Registration from "../pages/Auth/Registration";
import About from "../pages/About";
import AboutUs from "../pages/AboutUs";
import Events from "../pages/Events";
import Achievers from "../pages/Achievers";
import ContactUs from "../pages/ContactUs";
import SingleEvent from "../pages/SingleEvent";
import Matrimonial from "../pages/Protected/Matrimonial";
import ResetPassword from "../pages/Auth/ResetPassword";
import UserManager from "../pages/Protected/UserManager";
import Dashboard from "../pages/Protected/Dashboard";
import EventManager from "../pages/Protected/EventManager";
import NotFoundRoute from "../pages/NotFoundRoute";
import VolenteerManager from "../pages/Protected/VolenteerManager";
import MemberInfo from "../pages/Protected/MemberManager";
import MemberDetail from "../pages/Protected/MemberDetail";
import Photos from "../pages/Photos";
import Payment from "../pages/Protected/Payment/index";
import SuvicharManager from "../pages/Protected/SuvicharManager/index";
import EmployementManager from "../pages/Protected/EmployementManager";
import ViewBiodata from "../pages/Protected/Matrimonial/ViewBiodata";
import MemberSuvichar from "../pages/Protected/MemberSuvichar/MemberSuvichar";
import AddEditMetrimonial from "../pages/Protected/Matrimonial/AddEditMetrimonial";
import UserView from "../pages/Protected/UserManager/UserView";
import MemberJobEmployment from "../pages/Protected/MemberJobEmployment";
import Suggestion from "../pages/Suggestion";
import ContactusManager from "../pages/Protected/ContactusManager";
import SuggestionManager from "../pages/Protected/SuggestionManager";
import InterestMatrimonialManager from "../pages/Protected/InterestMatrimonial";

const RoutesComponent = () => {
  const routes = useRoutes([
    {
      path: "/",
      element: <Layout />,
      children: [
        { path: "/login", element: <Login /> },
        { path: "/", element: <Home /> },
        { path: "/forgot-password", element: <ForgotPassword /> },
        { path: "/registration", element: <Registration /> },
        { path: "/about", element: <About /> },
        { path: "/about-us", element: <AboutUs /> },
        { path: "/events", element: <Events /> },
        { path: "/achievers", element: <Achievers /> },
        { path: "/contact-us", element: <ContactUs /> },
        { path: "/photo", element: <Photos /> },
        { path: "/events/:id", element: <SingleEvent /> },
        { path: "/dashboard", element: <Dashboard /> },
        { path: "/matrimonial-post", element: <Matrimonial /> },
        { path: "/reset-password/:id", element: <ResetPassword /> },
        { path: "/member-manager", element: <UserManager /> },
        { path: "/member-view/:id", element: <UserView /> },
        { path: "/event-manager", element: <EventManager /> },
        { path: "/team-manager", element: <VolenteerManager /> },
        { path: "*", element: <NotFoundRoute /> },
        { path: "/member-info", element: <MemberInfo /> },
        { path: "/member-detail", element: <MemberDetail /> },
        { path: "/payment-manager", element: <Payment /> },
        { path: "/suvichar-manager", element: <SuvicharManager /> },
        { path: "/employment-manager", element: <EmployementManager /> },
        { path: "/view-biodata/:id", element: <ViewBiodata /> },
        { path: "/add-biodata", element: <AddEditMetrimonial /> },
        { path: "/edit-biodata/:id", element: <AddEditMetrimonial /> },
        { path: "/suvichar-post", element: <MemberSuvichar /> },
        { path: "/employment-post", element: <MemberJobEmployment /> },
        { path: "/suggestion", element: <Suggestion /> },
        { path: "/contect-us-manager", element: <ContactusManager /> },
        { path: "/suggestion-manager", element: <SuggestionManager /> },
        { path: "/matrimonial-manager", element: <InterestMatrimonialManager /> },
      ],
    },
  ]);

  return routes;
};

export default RoutesComponent;
